import { Dispatch, SetStateAction } from 'react';
import moment from "moment";

interface Event {
    id: string;
    title: string;
    start: Date;
    end: Date;
    status: string;
    problems: string;
    hasProblem: boolean;
}


type SetSelectedEvents = Dispatch<SetStateAction<Event[]>>;
type SetIsModalOpen = Dispatch<SetStateAction<boolean>>;
type SetStarting = Dispatch<SetStateAction<Date>>;
export const handleSelectSlot = (
    start: Date,
    end: Date,
    eventsData: Event[],
    setSelectedEvents: SetSelectedEvents,
    setIsModalOpen: SetIsModalOpen,
    setStarting: SetStarting
): void => {
    setStarting(start);
    // Преобразование дат в формат ISO
    const formattedEvents = eventsData.map(event => ({
        ...event,
        startFormatted: event.start.toISOString(),
        endFormatted: event.end.toISOString(),
    }));

    // Фильтрация событий
    const eventsInSlot = formattedEvents.filter(
        (event) =>
            moment(event.startFormatted).isBetween(start, end, null, '[]') ||
            moment(event.endFormatted).isBetween(start, end, null, '[]') ||
            (moment(event.startFormatted).isSameOrBefore(start) && moment(event.endFormatted).isSameOrAfter(end))
    );

    setSelectedEvents(eventsInSlot);

    // Открывать модальное окно только если есть события
    if (eventsInSlot.length > 0) {
        setIsModalOpen(true);
    }
};
